import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess} from '@/utils/notification';
import {
  GET_STUDENTUNITLEARN,
  GET_STUDENTUNITLEARNS,
  GET_STUDENTUNITLEARNS_BY_FILTER,
  ADD_STUDENTUNITLEARN,
  UPDATE_STUDENTUNITLEARN,
} from '@/queries/modules/student-unit-learn/student-unit-learn.js';

export async function getStudentUnitLearns(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTUNITLEARNS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentUnitLearns', data.getStudentUnitLearns);
      context.commit('setSuccess', null);
      return data.getStudentUnitLearns
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentUnitLearnsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTUNITLEARNS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentUnitLearns', data.getStudentUnitLearnsByFilter);
      context.commit('setSuccess', null);

      return data.getStudentUnitLearnsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentUnitLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTUNITLEARN,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setStudentUnitLearn', data.getStudentUnitLearn);
      context.commit('setSuccess', null);
      return data.getStudentUnitLearn
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentUnitLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTUNITLEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const studentUnitLearns = [...context.state.studentUnitLearns];
      studentUnitLearns.push(data.addStudentUnitLearn);
      context.commit('setStudentUnitLearns', studentUnitLearns);
      context.commit('setSuccess', newItemSuccess(data.addStudentUnitLearn.unitSeq));

      return data.addStudentUnitLearn;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentUnitLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTUNITLEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentUnitLearns.findIndex(item => item.id === data.updateStudentUnitLearn.id);
      const studentUnitLearns = [
        ...context.state.studentUnitLearns.slice(0, index),
        data.updateStudentUnitLearn,
        ...context.state.studentUnitLearns.slice(index + 1)
      ];
      context.commit('setStudentUnitLearns', studentUnitLearns);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentUnitLearn.unitSeq));

      return data.updateStudentUnitLearn
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
